import styled from 'styled-components'

import Aspas from '../../images/aspas.svg'

export const BannerSobre = styled.section`
  width: 100%;
  height: 395px;
  padding-top: 72px;
  background: ${props => (props.bg ? 'url(' + props.bg + ')' : 'linear-gradient(0deg, #02A9CE -22.08%, #0095DA 89.23%)')};
  background-position: center;
  background-size: initial;
  background-repeat: no-repeat;
  .container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  h1 {
    max-width: 500px;
  }
  .box {
    position: relative;
    background: #ffffff;
    box-shadow: 0px 13px 30px rgba(121, 155, 179, 0.22);
    border-radius: 8px 0px;
    width: 654px;
    height: 322px;
    margin-top: 46px;
    margin-right: -50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 85px;
    .icone {
      position: absolute;
      bottom: -78px;
      left: 0;
    }
    .cont {
      position: relative;
      max-width: 438px;
      &:before {
        content: '';
        width: 71px;
        height: 61px;
        background: url(${Aspas}) no-repeat center center;
        position: absolute;
        top: -32px;
        left: -59px;
      }
    }
    p {
      font: normal 400 18px/28px 'DepotNew';
      color: #636466;
      margin-bottom: 35px;
    }
    h3 {
      font: normal bold 18px/26px 'DepotNew';
      color: #0095da;
    }
  }
  @media (max-width: 1050px) {
    height: auto;
    padding: 40px 0px;
    background-size: cover;
    .container {
      flex-direction: column;
      align-items: center;
    }
    .box {
      margin-right: 0;
      .icone {
        bottom: -20px;
      }
    }
  }
  @media (max-width: 480px) {
    height: auto;
    padding: 40px 0px;
    background-size: cover;
    h1 {
      font-size: 32px;
      line-height: 43px;
      margin-top: 20px;
    }
    .box {
      width: 100%;
      height: auto;
      padding: 40px 30px;
      margin-top: 20px;
      .icone {
        display: none;
      }
      p {
        font-size: 16px;
        margin-bottom: 20px;
      }
      h3 {
        font-size: 16px;
      }
      .cont {
        &:before {
          left: 0;
        }
      }
    }
  }
`

export const CuidadoPessoas = styled.section`
  padding-top: 219px;
  padding-bottom: 266px;
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  button {
    height: 60px;
  }
  .area-slide {
    width: 669px;
    overflow: hidden;
    .swiper-container {
      .swiper-slide {
        img {
          border-radius: 12px 0px 12px 0px;
          display: block;
        }
      }
      &:last-child {
        margin-top: 28px;
        .swiper-slide {
          width: 25%;
          opacity: 0.5;
          transition: all 0.3s;
          &.swiper-slide-active {
            opacity: 1;
            transition: all 0.3s;
          }
          img {
            border-radius: 12px 0px 12px 0px;
          }
        }
      }
    }

    .swiper-slide {
      img {
        width: 100%;
      }
    }
    .ctrl-slide {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .btn {
        cursor: pointer;
        &.btn-prev {
          margin-right: 15px;
        }
      }
      .swiper-pagination {
        position: relative;
        bottom: 0;
        .swiper-pagination-bullet {
          background-color: #d8d9d9;
          border-radius: 4.5px;
          width: 10px;
          height: 9px;
          opacity: 1;
          margin: 0px 3px;
          transition: all 0.3s;
          &.swiper-pagination-bullet-active {
            background-color: #5cb4e7;
            width: 25px;
            transition: all 0.3s;
          }
        }
      }
    }
  }
  .texto {
    max-width: 438px;
    margin-top: -100px;
    h3 {
      font: normal bold 36px/40px 'DepotNew';
      color: #3c3d40;
      margin-bottom: 24px;
    }
    p {
      font-size: 15px;
      line-height: 24px;
      color: #94969b;
      margin-bottom: 40px;
    }
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 320px;
      height: 50px;
      padding: 0px 57px;
      background-color: #0ac4ac;
      border: 2px solid #0ac4ac;
      border-radius: 8px 0px;
      font: normal 500 15px/18px 'DepotNew';
      text-align: center;
      color: #ffffff;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        background-color: transparent;
        color: #0ac4ac;
        transition: all 0.3s;
      }
    }
  }
  @media (max-width: 1050px) {
    height: auto;
    padding-bottom: 40px;
    .flex {
      flex-direction: column;
      align-items: center;
    }
    .container {
      width: 100%;
    }
    .texto {
      margin-top: 60px;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        text-align: center;
        font-size: 16px;
      }
    }
  }
  @media (max-width: 480px) {
    padding: 40px 0px;
    .area-slide {
      width: 100%;
      margin-top: 25px;
    }
    .texto {
      margin-top: 30px;
      h3 {
        max-width: 240px;
        text-align: center;
        font-size: 28px;
        line-height: 35px;
        margin-bottom: 10px;
      }
      p {
        margin-bottom: 20px;
        font-size: 14px;
      }
    }
  }
`

export const Encontros = styled.section`
  height: 507px;
  background: #f5f6fa;
  .cont {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .area-slide {
    width: 669px;
    overflow: hidden;
    margin-top: -124px;
    .swiper-container {
      .swiper-slide {
        position: relative;
        .icon-play {
          position: absolute;
          z-index: 1;
          background: #ffffff;
          box-shadow: 0px 10px 26px rgba(0, 98, 166, 0.412833);
          width: 25px;
          height: 25px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          left: 50%;
          top: 50%;
          margin-top: -12.5px;
          margin-left: -12.5px;
          transition: all 0.3s;
          img {
            max-width: 4px;
          }
        }
      }
      &:last-child {
        margin-top: 28px;
        .swiper-slide {
          width: 25%;
          cursor: pointer;
          opacity: 0.5;
          transition: all 0.3s;
          &.swiper-slide-active {
            opacity: 1;
            transition: all 0.3s;
          }
          &:hover {
            .icon-play {
              transform: scale(1.1);
              transition: all 0.3s;
            }
          }
          img {
            width: 100%;
          }
        }
      }
      img {
        width: 100%;
        border-radius: 12px 0px 12px 0px;
      }
    }
    .ctrl-slide {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .btns {
        display: flex;
        .btn {
          cursor: pointer;
          &.btn-prev {
            margin-right: 15px;
          }
        }
      }
      .swiper-pagination {
        position: relative;
        bottom: 0;
        .swiper-pagination-bullet {
          background-color: #d8d9d9;
          border-radius: 4.5px;
          width: 10px;
          height: 9px;
          opacity: 1;
          margin: 0px 3px;
          transition: all 0.3s;
          &.swiper-pagination-bullet-active {
            background-color: #5cb4e7;
            width: 25px;
            transition: all 0.3s;
          }
        }
      }
    }
  }
  .texto {
    padding-top: 146px;
    max-width: 384px;
    h2 {
      font: normal bold 36px/40px 'DepotNew';
      color: #3c3d40;
      margin-bottom: 28px;
    }
    p {
      font-size: 15px;
      line-height: 24px;
      color: #94969b;
    }
  }
  @media (max-width: 1050px) {
    height: auto;
    padding: 40px 0px;
    .cont {
      flex-direction: column;
      align-items: center;
    }
    .texto {
      padding-top: 0px;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      p {
        text-align: center;
      }
    }
    .area-slide {
      width: 100%;
      margin-top: 40px;
    }
  }
  @media (max-width: 480px) {
    .texto {
      h2 {
        font-size: 28px;
        line-height: 1;
        margin-bottom: 20px;
      }
    }
    .video {
      height: 190px !important;
    }
  }
`

export const AreaVideo = styled.div`
  overflow: hidden;
  border-radius: 12px 0px 12px 0px;
  .video {
    width: 100% !important;
    .react-player__shadow {
      background: none !important;
      width: 90px !important;
      height: 90px !important;
      border-radius: 50% !important;
      box-shadow: 0px 10px 26px rgba(0, 98, 166, 0.412833) !important;
      background-color: #ffffff !important;
      .react-player__play-icon {
        border-width: 12.5px 0px 12.5px 16px !important;
        border-color: transparent transparent transparent #0095da !important;
      }
    }
  }
`
